require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/modules/es7.symbol.observable.js
// module id = 429
// module chunks = 0